import BaseItemId from 'owa-service/lib/contract/BaseItemId';
import ConversationItem from 'mini-mail-list-store/lib/store/schema/ConversationItem';
import ConversationType from 'owa-service/lib/contract/ConversationType';
import ItemId from 'owa-service/lib/contract/ItemId';
import TableQuery from 'mini-mail-list-store/lib/store/schema/TableQuery';

function mapBaseItemIdsToItemIds(baseItemIds: BaseItemId[]): string[] {
    const itemIds: string[] = [];
    for (const baseItemId of baseItemIds) {
        const itemId: ItemId = <ItemId>{ ...baseItemId };
        itemIds.push(itemId.Id);
    }
    return itemIds;
}

export default function mapConversationTypeToConversationItem(
    conversationType: ConversationType,
    tableQuery: TableQuery
): ConversationItem {
    const itemIds = mapBaseItemIdsToItemIds(conversationType.GlobalItemIds);

    const conversationItem: ConversationItem = {
        id: conversationType.ConversationId.Id,
        subject: conversationType.ConversationTopic,
        recipients: null,
        globalItemIds: itemIds,
        globalLikeCount: conversationType.GlobalLikeCount,
    };

    return conversationItem;
}
